import React from 'react';
import { resolveTheme, panelStyle } from '../themes';
import type { Theme } from '../themes';

interface FullscreenToggleProps {
  theme?: string | Theme;
  isFullscreen: boolean;
  onToggle: () => void;
}

export function FullscreenToggle({ theme, isFullscreen, onToggle }: FullscreenToggleProps) {
  const T = resolveTheme(theme);

  return (
    <button
      aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
      onClick={onToggle}
      className="fullscreen-toggle"
      style={panelStyle(T, {
        padding: '6px 12px', display: 'flex', alignItems: 'center', gap: 8,
        cursor: 'pointer', appearance: 'none', font: `11px ${T.font}`,
      })}
    >
      <span style={{ fontSize: 14 }}>{isFullscreen ? '⊡' : '⊞'}</span>
      <span style={{ color: T.textDim, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        {isFullscreen ? 'Exit' : 'Fullscreen'}
      </span>
      <span style={{ color: T.textDim, opacity: 0.5, fontSize: 10, marginLeft: 4 }}>F</span>
    </button>
  );
}
